<template>
  <div class="p-3 mt-3 maadi-inlay align-items-center">
    <div class="d-flex">
      <div style="font-size: 1.3em;" class="mb-2">
        {{ account.name }}
      </div>
      <div class="ml-auto">
        <button class="btn maadi-button" @click="showSurveyGenerator = !showSurveyGenerator">
          {{ showSurveyGenerator ? 'Hide Survey Generator' : 'Generate Survey' }}
        </button>
      </div>
    </div>
    <transition name="fade">
      <div v-if="showSurveyGenerator">
        <div>
          <div class="mb-1" style="font-weight: 300">Short introduction text - no carriage returns allowed.</div>
          <b-form-textarea
            id="textarea"
            v-model="surveyMessage"
            placeholder="Enter something..."
            rows="3"
            max-rows="6"
            style="border-radius: 0"
          ></b-form-textarea>
        </div>
        <div class="mt-2 d-flex">
          <div class="mr-3">
            <button @click="shortenLink" class="btn maadi-button btn-sm">
              Create link
            </button>
          </div>
          <div class="flex-fill">
            <div>
              <div v-if="isShortenLinkBeingGenerated">
                <div class="spinner-border text-light" role="status"></div>
              </div>
              <div class="ml-auto d-flex" v-if="bitlyLink !== null">
                <b-form-input  size="sm" v-model="bitlyLink"></b-form-input>
                <a target="_blank" :href="bitlyLink" class="btn maadi-button btn-sm ml-2"><i class="fas fa-arrow-circle-right"></i></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import API from '../../api/_services'

export default {
  name: '',
  props: ['activity', 'account'],
  data: function () {
    return {
      surveyMessage: null,
      showSurveyGenerator: false,
      bitlyLink: null,
      isShortenLinkBeingGenerated: false
    }
  },
  methods: {
    shortenLink: function () {
      this.isShortenLinkBeingGenerated = true
      API.post(process.env.ROOT_API + '/administration/link-shortener',
        {
          'title': 'Activity Satisifaction Survey #' + this.account.activity_id,
          'tags': [],
          'url': this.surveyURL
        }).then(
        response => {
          console.log(response)
          this.isShortenLinkBeingGenerated = false
          let data = response.data
          this.bitlyLink = data.link
        }
      )
    }
  },
  computed: {
    surveyURL () {
      return 'https://medicalalley.typeform.com/to/RrcTsv1a#activity_id=' + this.account.activity_id + '&intro_text=' + this.surveyMessage
    }
  },
  mounted () {
    this.surveyMessage = 'On ' + this.activity.start_date_string + ' you received a referral from ' + this.activity.user_name + '...'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/activities/SingleAccountInActivity.vue